<template>
    <div class="works">
        <div class="wrap-c">
            <h1 class="large-title title">How it works</h1>
            <div class="works-box">
                <ul class="works-list">
                    <li class="works-item" v-for="(item,index) in works" :key="index">
                        <div class="works-imgs">
                            <img style="width:100%" :src="item.imgs" alt="nonda">
                        </div>
                        <h2 class="middle-title item-title">{{ item.title }}</h2>
                        <p class="item-text">{{ item.text }}</p>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent,toRefs,reactive } from 'vue';

export default defineComponent({
  setup(){
      interface DataProps{
          works:{
              imgs: string,
              title: string,
              text: string
          }[]
      }
      const data:DataProps = reactive({
          works:[
                {
                    imgs:require("../../assets/imgs/home/work_a.png"),
                    title:'Invite Friends',
                    text:'Invite your friends to claim the FREE ZUS device by email, sharing your link or posting on social.'
                },
                {
                    imgs:require("../../assets/imgs/home/work_b.png"),
                    title:'Earn Real Cash',
                    text:'Get real cash when your friends claim their free ZUS with your link.'
                },
                {
                    imgs:require("../../assets/imgs/home/work_c.png"),
                    title:'Repeat',
                    text:'Keep referring friends! The more you invite, the more you earn.'
                }
          ]
      })
      const refData = toRefs(data)
      return {
          ...refData
      }
  }
})
</script>
<style lang="scss" scoped>
.works{
    padding: 20px 0;
    .title{
        margin-bottom: 20px;
    }
}
.wrap-c {
    max-width: 1024px;
    margin: 0 auto;
    height: 100%;
    overflow: hidden;
}
.works-list{
    display: flex;
    justify-content: space-between;
    .works-item{
        width: 33%;
        color: #333333;
        .works-imgs{
            width: 188px;
            margin: 0 auto;
        }
        .item-title{
            margin: 10px 0;
        }
        .item-text{
            font-size: 18px;
        }
    }
}
@media screen and (max-width: 768px){
    .wrap-c{
        padding: 0 10px;
    }
    .works-list{
        flex-wrap: wrap;
        .works-item{
            width: 100%;
        }
    }
}
</style>
